module.exports = __webpack_public_path__ + "img/img2-2.515f9729.png";